module.exports = __webpack_public_path__ + "static/flags/DO-13e17f33908a0469ab61ac523a88e63e.gif";